import { defaultAgent, apiResponse } from '../helpers/web-agent';
import { toastError, toastSuccess } from './toast';
import { tokenExpired } from './auth';
import { parseLoadListFromManual } from "../interceptors/load";
import {
	SET_LOAD_QUEUE_TYPE, LOAD_QUEUE_LIST_REQUEST, LOAD_QUEUE_LIST,
	LOAD_QUEUE_COUNT, LOAD_QUEUE_APPROVED, UNLOAD_SITE_QUEUE_LIST,
	LOAD_QUEUE_APPROVAL_CANCELLED, LOAD_TRIP_LIST_REQUEST,
	LOAD_TRIP_LIST, SET_SELECTED_LOAD_IDS, SET_LOAD_HISTORY_SHOW_MODAL, SET_LOAD_HISTORY_PARAMS,
	PICKED_LIST, PICKED_LIST_REQUEST, TOTAL_LOAD_TRIP_COUNT_REQUEST, TOTAL_LOAD_TRIP_COUNT, SET_LOAD_QUEUE_SEARCH_TEXT, SET_LOAD_QUEUE_INPUTS,
	SET_LOAD_QUEUE_SORT_ORDER, SET_LOAD_QUEUE_FILTER_IDS, SET_LOAD_QUEUE_FILTERS, SET_LOAD_TIMELINE, SET_LOAD_TIMELINE_REQUEST, SET_TARE_LOAD,
	SET_TARE_LOAD_REQUESTING, UPDATE_TARE_LOAD, UPDATE_LOAD_LIST, SET_AI_CHAT_BOT, SET_AI_CHAT_MESSAGE, SET_AI_CHAT_BOT_ID, GET_LOAD_REGION_LIST, GET_LOAD_REGION_LIST_REQUESTING, GET_LOAD_SOURCE_EG_LIST, GET_LOAD_SOURCE_EG_LIST_REQUESTING, SET_PLANTING_QUEUE_INPUTS,
	REMOVE_LOAD_QUEUE_DATA,
	SET_ISCOMPLETE, SET_IS_NEED_PLANTER_VALUES,
	LOAD_QUEUE_CUSTOMER_LIST,
	LOAD_QUEUE_CUSTOMER_LIST_REQUEST, SET_LOAD_HISTORY_RELOAD
} from '../constants/action-types';
import { LOAD_APPROVED, LOAD_APPROVAL_CANCELLED, LOAD_COMPLETED, MOVE_LOAD_INCOMPLETE } from '../constants/messages';
import { VIEW_EG } from '../constants';

export const setLoadQueueType = payload => ({ type: SET_LOAD_QUEUE_TYPE, payload });

export const setLoadQueueNotes = (load, data) => ({ type: UPDATE_LOAD_LIST, load, data });

export const removeLoadQueueData = (loadActivityId) => ({ type: REMOVE_LOAD_QUEUE_DATA, loadActivityId });

export const loadQueueListRequest = () => ({ type: LOAD_QUEUE_LIST_REQUEST });

export const loadQueueList = payload => ({ type: LOAD_QUEUE_LIST, payload });

export const loadQueueCustomerListRequest = () => ({ type: LOAD_QUEUE_CUSTOMER_LIST_REQUEST });

export const loadQueueCutomerList = payload => ({ type: LOAD_QUEUE_CUSTOMER_LIST, payload });

export const unLoadSiteList = payload => ({ type: UNLOAD_SITE_QUEUE_LIST, payload });

export const loadQueueCount = payload => ({ type: LOAD_QUEUE_COUNT, payload });

export const loadApproved = payload => ({ type: LOAD_QUEUE_APPROVED, payload });

export const loadApprovalCancelled = payload => ({ type: LOAD_QUEUE_APPROVAL_CANCELLED, payload });

export const loadTripListRequest = () => ({ type: LOAD_TRIP_LIST_REQUEST });

export const loadTripList = payload => ({ type: LOAD_TRIP_LIST, payload });

export const pickedList = data => ({ type: PICKED_LIST, payload: data });

export const pickedListRequest = () => ({ type: PICKED_LIST_REQUEST });

export const totalPickedLoadTripCountRequest = () => ({ type: TOTAL_LOAD_TRIP_COUNT_REQUEST });

export const totalPickedLoadTripCount = payload => ({ type: TOTAL_LOAD_TRIP_COUNT, payload });

export const setSelectedLoadIds = payload => ({ type: SET_SELECTED_LOAD_IDS, payload });

export const setLoadQueueInputs = payload => ({ type: SET_LOAD_QUEUE_INPUTS, payload })

export const setLoadQueueSortOrder = payload => ({ type: SET_LOAD_QUEUE_SORT_ORDER, payload });

export const setLoadQueueFilterIds = payload => ({ type: SET_LOAD_QUEUE_FILTER_IDS, payload });

export const setLoadQueueFilters = payload => ({ type: SET_LOAD_QUEUE_FILTERS, payload });

export const setLoadHistoryShowModal = payload => ({ type: SET_LOAD_HISTORY_SHOW_MODAL, payload });

export const setLoadHistoryParams = payload => ({ type: SET_LOAD_HISTORY_PARAMS, payload });

export const setLoadQueueSearchText = payload => ({ type: SET_LOAD_QUEUE_SEARCH_TEXT, payload });

export const loadTimeLineRequest = payload => ({ type: SET_LOAD_TIMELINE_REQUEST, payload });

export const setLoadTimeLine = payload => ({ type: SET_LOAD_TIMELINE, payload });

export const setTareLoadRequesting = payload => ({ type: SET_TARE_LOAD_REQUESTING });

export const setTareLoad = payload => ({ type: SET_TARE_LOAD, payload });

export const setAiChatButton = payload => ({ type: SET_AI_CHAT_BOT, payload });

export const setAiChatBotMessages = payload => ({ type: SET_AI_CHAT_MESSAGE, payload });

export const setAiChatBotId = payload => ({ type: SET_AI_CHAT_BOT_ID, payload });

export const updateTareLoad = payload => ({ type: UPDATE_TARE_LOAD, payload });

export const loadRegionListRequesting = () => ({ type: GET_LOAD_REGION_LIST_REQUESTING });

export const loadRegionList = payload => ({ type: GET_LOAD_REGION_LIST, payload });

export const planterEgListRequesting = () => ({ type: GET_LOAD_SOURCE_EG_LIST_REQUESTING });

export const planterEgList = payload => ({ type: GET_LOAD_SOURCE_EG_LIST, payload })

export const setPlantingQueueInputs = payload => ({ type: SET_PLANTING_QUEUE_INPUTS, payload })

export const setIsComplete = payload => ({ type: SET_ISCOMPLETE, payload });

export const setIsNeedPlanterValues = payload => ({ type: SET_IS_NEED_PLANTER_VALUES, payload });

export const setIsLoadHistoryReload = payload => ({ type: SET_LOAD_HISTORY_RELOAD, payload });

export const getLoadQueueCount = data => dispatch => {
	const params = {
		farm_uuid: data.farmId,
		range_type: data.rangeType,
		start_date: data.fromDate,
		end_date: data.toDate,
		is_current_customer_load: data.is_current_customer_load,
		__t: new Date().getTime()
	};

	let APIName = 'equipment/group';
	let APIsubName = 'notapproved';
	if (data && data.planTypeId) {
		switch (data.planTypeId) {
			case 5:
				APIName = 'logistics';
				break;
			case 2: {
				const planterAllocation = (data && data.is_planter_allocation) ? true : false;
				APIName = 'seed';
				APIsubName = planterAllocation ? 'incomplete' : 'notapproved';
				break;
			}
			default:
				break;
		}
	};

	defaultAgent.get(`/api/${APIName}/load/${APIsubName}/count`, params, { requestId: "loadQueueCount" })
		.then(res => {
			const agentResult = apiResponse(res);
			if (agentResult.isUnauthorized) {
				dispatch(toastError(agentResult.message));
				dispatch(tokenExpired());
			} else if (agentResult.message) {
				dispatch(toastError(agentResult.message));
				dispatch(loadQueueCount());
			} else if (agentResult.data) {
				dispatch(loadQueueCount(agentResult.data));
			}
		}).catch(ex => {
			if (defaultAgent.isCancel(ex)) return console.log('Load Queue Count: ', ex.message);
			dispatch(toastError(ex.message, getToastOptions()));
		});
};

export const getLoadQueueList = data => dispatch => {
	let params = {
		farm_uuid: data.farmId,
		range_type: data.rangeType,
		start_date: data.fromDate,
		end_date: data.toDate,
		approved: data.approved,
		is_current_customer_load: data.is_current_customer_load
	};

	let APIName = 'equipment/group';
	if (data && data.planTypeId) {
		switch (data.planTypeId) {
			case 5:
				APIName = 'logistics';
				break;
			case 2:
				APIName = 'seed';
				if (data.hasOwnProperty('approved')) {
					params['approved'] = data.approved ? data.approved : false;
				} else {
					params['completed'] = data.completed ? data.completed : false;
				}
				break;
			default:
				break;
		}
	};

	dispatch(loadQueueListRequest());
	defaultAgent.get(`/api/${APIName}/load/list`, params, { requestId: "loadQueueList" })
		.then(res => {
			const agentResult = apiResponse(res);
			if (agentResult.isUnauthorized) {
				dispatch(toastError(agentResult.message));
				dispatch(tokenExpired());
			} else if (agentResult.message) {
				dispatch(toastError(agentResult.message));
				dispatch(loadQueueList());
			} else if (agentResult.data) {
				dispatch(loadQueueList(parseLoadListFromManual(agentResult.data)));
			}
		}).catch(ex => {
			if (defaultAgent.isCancel(ex)) return console.log('Load Queue List: ', ex.message);
			dispatch(toastError(ex.message));
			dispatch(loadQueueList());
		});
};

export const getLoadQueueCustomerList = (data) => dispatch => {
	let params = {
		farm_uuid: data.farm_uuid
	};
	dispatch(loadQueueCustomerListRequest());
	defaultAgent.post(`/api/common/dropdown/list`, params)
		.then(res => {
			const agentResult = apiResponse(res);
			if (agentResult.isUnauthorized) {
				dispatch(toastError(agentResult.message));
				dispatch(tokenExpired());
			} else if (agentResult.message) {
				dispatch(toastError(agentResult.message));
				dispatch(loadQueueCutomerList());
			} else if (agentResult.data) {
				dispatch(loadQueueCutomerList(agentResult.data));
			}
		}).catch(ex => {
			dispatch(toastError(ex.message));
			dispatch(loadQueueCutomerList());
		});
}

export const getUnLoadSiteList = (farmId, cb = null) => dispatch => {
	const params = {
		farm_uuid: farmId,
		include_location: true,
		include_properties: true,
		geo_region_type_id: 4
	};

	defaultAgent.get(`/api/geo/shape/list`, params)
		.then(res => {
			const agentResult = apiResponse(res);
			if (agentResult.isUnauthorized) {
				dispatch(toastError(agentResult.message));
				dispatch(tokenExpired());
				if (cb) cb([]);
			} else if (agentResult.message) {
				dispatch(toastError(agentResult.message));
				dispatch(unLoadSiteList());
				if (cb) cb([]);
			} else if (agentResult.data) {
				dispatch(unLoadSiteList(agentResult.data));
				if (cb) cb(agentResult.data);
			}
		}).catch(ex => {
			dispatch(toastError(ex.message));
			dispatch(unLoadSiteList());
			if (cb) cb([]);
		});
};

export const approveLoad = (params, cb) => dispatch => {
	const toastOptions = getToastOptions();

	let APIName = 'equipment/group';
	if (params && params.planTypeId) {
		switch (params.planTypeId) {
			case 5:
				APIName = 'logistics';
				break;
			case 2:
				APIName = 'seed';
				break;
			default:
				break;
		}
	};

	defaultAgent.put(`/api/${APIName}/load/approve`, params)
		.then(res => {
			const agentResult = apiResponse(res);
			if (agentResult.isUnauthorized) {
				dispatch(toastError(agentResult.message));
				dispatch(tokenExpired());
			} else if (agentResult.code === LOAD_APPROVED.code) {
				dispatch(toastSuccess(LOAD_APPROVED.message, toastOptions));
				dispatch(loadApproved(params));
				if (cb) cb(true);
			}
			else if (agentResult.message) {
				dispatch(toastError(agentResult.message, toastOptions));
				if (cb) cb(false);
			}
		}).catch(ex => {
			dispatch(toastError(ex.message, toastOptions));
			if (cb) cb(false);
		});
};

export const completedLoad = (params, cb) => dispatch => {
	const toastOptions = getToastOptions();

	let APIName = 'equipment/group';
	if (params && params.planTypeId) {
		switch (params.planTypeId) {
			case 5:
				APIName = 'logistics';
				break;
			case 2:
				APIName = 'seed';
				break;
			default:
				break;
		}
	};

	defaultAgent.put(`/api/${APIName}/load/complete`, params)
		.then(res => {
			const agentResult = apiResponse(res);
			if (agentResult.isUnauthorized) {
				dispatch(toastError(agentResult.message));
				dispatch(tokenExpired());
			} else if (agentResult.code === LOAD_COMPLETED.code) {
				dispatch(toastSuccess(LOAD_COMPLETED.message, toastOptions));
				dispatch(loadApproved(params));
				if (cb) cb(true);
			}
			else if (agentResult.message) {
				dispatch(toastError(agentResult.message, toastOptions));
				if (cb) cb(false);
			}
		}).catch(ex => {
			dispatch(toastError(ex.message, toastOptions));
			if (cb) cb(false);
		});
};

export const cancelApproval = (params, cb) => dispatch => {
	const toastOptions = getToastOptions();

	let APIName = 'equipment/group';
	if (params && params.planTypeId) {
		switch (params.planTypeId) {
			case 5:
				APIName = 'logistics';
				break;
			case 2:
				APIName = 'seed';
				break;
			default:
				break;
		}
	};

	defaultAgent.put(`/api/${APIName}/load/cancelapproval`, params)
		.then(res => {
			const agentResult = apiResponse(res);
			if (agentResult.isUnauthorized) {
				dispatch(toastError(agentResult.message));
				dispatch(tokenExpired());
			} else if (agentResult.code === LOAD_APPROVAL_CANCELLED.code) {
				dispatch(toastSuccess(LOAD_APPROVAL_CANCELLED.message, toastOptions));
				dispatch(loadApprovalCancelled(params));
				if (cb) cb(true);
			}
			else if (agentResult.message) {
				dispatch(toastError(agentResult.message, toastOptions));
				if (cb) cb(false);
			}
		}).catch(ex => {
			dispatch(toastError(ex.message, toastOptions));
			if (cb) cb(false);
		});
};

export const inComplete = (params, cb) => dispatch => {
	const toastOptions = getToastOptions();

	let APIName = 'equipment/group';
	if (params && params.planTypeId) {
		switch (params.planTypeId) {
			case 5:
				APIName = 'logistics';
				break;
			case 2:
				APIName = 'seed';
				break;
			default:
				break;
		}
	};

	defaultAgent.put(`/api/${APIName}/load/incomplete`, params)
		.then(res => {
			const agentResult = apiResponse(res);
			if (agentResult.isUnauthorized) {
				dispatch(toastError(agentResult.message));
				dispatch(tokenExpired());
			} else if (agentResult.code === MOVE_LOAD_INCOMPLETE.code) {
				dispatch(toastSuccess(MOVE_LOAD_INCOMPLETE.message, toastOptions));
				dispatch(loadApprovalCancelled(params));
				if (cb) cb(true);
			}
			else if (agentResult.message) {
				dispatch(toastError(agentResult.message, toastOptions));
				if (cb) cb(false);
			}
		}).catch(ex => {
			dispatch(toastError(ex.message, toastOptions));
			if (cb) cb(false);
		});
};

export const getLoadTripList = data => dispatch => {
	const params = {
		farm_uuid: data.farmId,
		transporter_equipment_group_uuid: data.transporterEGId,
		farm_day_start: data.fromDate,
		farm_day_end: data.toDate
	};

	dispatch(loadTripListRequest());
	defaultAgent.get(`/api/farm/load-attribution`, params, { requestId: "loadTripList" })
		.then(res => {
			const agentResult = apiResponse(res);
			if (agentResult.isUnauthorized) {
				dispatch(toastError(agentResult.message));
				dispatch(tokenExpired());
			} else if (agentResult.message) {
				dispatch(toastError(agentResult.message));
				dispatch(loadTripList());
			} else if (agentResult.data) {
				const trips = (agentResult.data.data || []).map(e => ({
					...e,
					trip_id: `${e.transporter_equipment_group_uuid}_${e.farm_day}_${e.visit_id}`
				}));
				dispatch(loadTripList(trips));
			}
		}).catch(ex => {
			if (defaultAgent.isCancel(ex)) return console.log('Load Trip List: ', ex.message);
			dispatch(toastError(ex.message));
			dispatch(loadTripList());
		});
};

export const getTotalPickedLoadTripCount = (params, cb) => dispatch => {
	dispatch(totalPickedLoadTripCountRequest());
	defaultAgent.get(`api/equipment/group/load/trip/count`, params)
		.then(res => {
			const agentResult = apiResponse(res);
			if (agentResult.isUnauthorized) {
				dispatch(toastError(agentResult.message));
				dispatch(tokenExpired());
				if (cb) cb();
			} else if (agentResult.message) {
				dispatch(toastError(agentResult.message));
				dispatch(totalPickedLoadTripCount());
				if (cb) cb();
			} else if (agentResult.data) {
				dispatch(totalPickedLoadTripCount(agentResult.data));
				if (cb) cb(agentResult.data);
			}
		}).catch(ex => {
			if (defaultAgent.isCancel(ex)) return console.log('Total Trip: ', ex.message);
			dispatch(toastError(ex.message));
			dispatch(totalPickedLoadTripCount());
			if (cb) cb();
		});
};

export const getPickedList = data => dispatch => {
	const params = {
		farm_uuid: data.farmId,
		with_load_activity: data.withLoadActivity,
		range_type: data.range,
		from_date: data.fromDate,
		to_date: data.toDate
	};
	dispatch(pickedListRequest());
	defaultAgent.get(`api/equipment/group/load/trip/list`, params)
		.then(res => {
			const agentResult = apiResponse(res);
			if (agentResult.isUnauthorized) {
				dispatch(toastError(agentResult.message));
				dispatch(tokenExpired());
			} else if (agentResult.message) {
				dispatch(toastError(agentResult.message));
				dispatch(pickedList());
			} else if (agentResult.data) {
				dispatch(pickedList(agentResult.data));
			}
		}).catch(ex => {
			if (defaultAgent.isCancel(ex)) return console.log('Picked List: ', ex.message);
			dispatch(toastError(ex.message));
			dispatch(pickedList());
		});
};

export const getLoadTimeLine = ({ farm_uuid, load_activity_uuid }) => dispatch => {
	dispatch(loadTimeLineRequest());

	defaultAgent.get(`api/equipment/group/load/timeline?farm_uuid=${farm_uuid}&load_activity_uuid=${load_activity_uuid}`)
		.then(res => {
			const agentResult = apiResponse(res);
			if (agentResult.isUnauthorized) {
				dispatch(toastError(agentResult.message));
				dispatch(tokenExpired());
			} else if (agentResult.message) {
				dispatch(toastError(agentResult.message));
				dispatch(setLoadTimeLine());
			} else if (agentResult.data) {
				dispatch(setLoadTimeLine(agentResult.data));
			}
		}).catch(ex => {
			if (defaultAgent.isCancel(ex)) return console.log('Picked List: ', ex.message);
			dispatch(toastError(ex.message));
			dispatch(setLoadTimeLine());
		});
};

export const getTareLoad = (params, cb) => dispatch => {
	dispatch(setTareLoadRequesting());
	const { farm_uuid, include_events, range_type, from_date, to_date, isTruck, view, egId, crew_uuid, is_tareload } = params;

	let apiName = '/plan';
	let reqParams = { farm_uuid, include_events, range_type, from_date, to_date, is_tareload };

	if (view && view === VIEW_EG) {
		apiName = '/equipment/group'
		reqParams = isTruck ?
			{ ...reqParams, target_equipment_group_uuid: egId } :
			{ ...reqParams, source_equipment_group_uuid: egId };
	}
	else if (crew_uuid) {
		apiName = '/crew';
		reqParams = { ...reqParams, crew_uuid }
	}

	defaultAgent.get(`/api${apiName}/load/v1/history`, reqParams)
		.then(res => {
			const agentResult = apiResponse(res);
			if (agentResult.isUnauthorized) {
				dispatch(toastError(agentResult.message));
				dispatch(tokenExpired());
				if (cb) cb();
			} else if (agentResult.message) {
				dispatch(toastError(agentResult.message));
				dispatch(setTareLoad());
				if (cb) cb();
			} else if (agentResult.data) {
				dispatch(setTareLoad(agentResult.data));
				if (cb) cb(agentResult.data);
			}
		}).catch(ex => {
			if (defaultAgent.isCancel(ex)) return console.log('Total Trip: ', ex.message);
			dispatch(toastError(ex.message));
			dispatch(setTareLoad());
			if (cb) cb();
		});
};

export const addTareLoad = (params, cb) => dispatch => {
	defaultAgent.post(`api/tare/load/add`, params)
		.then(res => {
			const agentResult = apiResponse(res);
			if (agentResult.isUnauthorized) {
				dispatch(toastError(agentResult.message));
				dispatch(tokenExpired());
			} else if (agentResult.message) {
				if (agentResult.code === 4021) dispatch(toastSuccess(agentResult.message));
				else dispatch(toastError(agentResult.message));
			}

			if (cb) cb();
		}).catch(ex => {
			if (defaultAgent.isCancel(ex)) return console.log('Total Trip: ', ex.message);
			dispatch(toastError(ex.message));
			if (cb) cb();
		});
};

export const editTareLoad = (params, cb) => dispatch => {
	defaultAgent.put(`api/equipment/group/load/edit`, params)
		.then(res => {
			const agentResult = apiResponse(res);
			if (agentResult.isUnauthorized) {
				dispatch(toastError(agentResult.message));
				dispatch(tokenExpired());
			} else if (agentResult.message) {
				if (agentResult.code === 4028) dispatch(toastSuccess(agentResult.message));
				else dispatch(toastError(agentResult.message));
			}

			if (cb) cb();
		}).catch(ex => {
			if (defaultAgent.isCancel(ex)) return console.log('Total Trip: ', ex.message);
			dispatch(toastError(ex.message));
			if (cb) cb();
		});
};

export const deleteTareLoad = (params, cb) => dispatch => {
	defaultAgent.put(`api/equipment/group/load/delete`, params)
		.then(res => {
			const agentResult = apiResponse(res);
			if (agentResult.isUnauthorized) {
				dispatch(toastError(agentResult.message));
				dispatch(tokenExpired());
			} else if (agentResult.message) {
				if (agentResult.code === 4019) dispatch(toastSuccess(agentResult.message));
				else dispatch(toastError(agentResult.message));
			}

			if (cb) cb();
		})
		.catch(ex => {
			dispatch(toastError(ex.message));
			if (cb) cb();
		});
};

export const getLoadRegionList = (params) => dispatch => {
	dispatch(loadRegionListRequesting());
	defaultAgent.get('/api/geo/shape/list', { farm_uuid: params.farm_uuid, geo_region_type_id: 2 })
		.then(res => {
			const agentResult = apiResponse(res, []);
			if (agentResult.isUnauthorized) {
				dispatch(toastError(agentResult.message));
				dispatch(tokenExpired());
			} else if (agentResult.message) {
				dispatch(loadRegionList([]));
				dispatch(toastError(agentResult.message));
			}
			else if (agentResult.data) {
				dispatch(loadRegionList(agentResult.data));
			}
		}).catch(ex => {
			if (defaultAgent.isCancel(ex)) return console.log(`Geo shape field list data: `, ex.message);
			dispatch(toastError(ex.message));
			dispatch(loadRegionList([]));
		});
};

export const getPlanterEGList = ({ farmId, selectedPlanType }) => dispatch => {
	const params = { farm_uuid: farmId, spec: 0, operator: 0, crew: 0, device: 0, img: 0, plan_type_id: selectedPlanType };
	defaultAgent.get('/api/equipment/group/v1/list', params)
		.then(res => {
			const agentResult = apiResponse(res, []);
			if (agentResult.isUnauthorized) {
				dispatch(toastError(agentResult.message));
				dispatch(tokenExpired());
			} else if (agentResult.message) {
				dispatch(toastError(agentResult.message));
				dispatch(planterEgList([]));
			} else if (agentResult.data) {
				dispatch(planterEgList(agentResult.data));
			}
		}).catch(ex => {
			dispatch(toastError(ex.message));
			dispatch(planterEgList([]));
		});
}

export const getToastOptions = () => ({ position: "top-left" });